import {Box} from '@shopify/polaris';
import {FeedbackCard} from 'components/FeedbackCard';
import {useSearch} from 'features/Translations/hooks';

import styles from './TranslatableResourceSideBar.scss';
import {Navigation, Search} from './components';

export interface Props {
  loading: boolean;
  onFetchCompleted?: (itemsCount: number) => void;
}

export function TranslatableResourceSideBar({
  loading,
  onFetchCompleted,
}: Props) {
  const {isActive: isSearchMode} = useSearch();

  return (
    <div className={styles.SideBarWrapper}>
      <Box minHeight="100%" background="bg-surface">
        <Box>
          <Search loading={loading} />
          <Navigation
            loading={loading}
            hidden={isSearchMode}
            onFetchCompleted={onFetchCompleted}
          />
        </Box>
        <FeedbackCard />
      </Box>
    </div>
  );
}
